// extracted by mini-css-extract-plugin
export default {"loanBreakdownContainer":"FundsSent_loanBreakdownContainer__uShRf","skeletonLoadingAnimation":"FundsSent_skeletonLoadingAnimation__2yk6R"};